import { useContext } from "react";

import { LLMFirewallContext } from "../../contexts/user/LLMFirewallContext";

const useLLMFirewall = () => {
  const context = useContext(LLMFirewallContext);
  return context;
};

export default useLLMFirewall;
